export const userRole = ['Editor', 'Admin'];

export default userRole;
